import React from 'react';
import { Turn } from '../../models/types';
import './AvailableTurns.css';

interface AvailableTurnsProps {
    turns: Turn[];
    selectedTurn: Turn | null;
    onTurnSelect: (turn: Turn) => void;
}

const AvailableTurns: React.FC<AvailableTurnsProps> = ({ turns, selectedTurn, onTurnSelect }) => {
    const handleTurnClick = (turn: Turn) => {
        if (turn.ask_shop) {
            window.confirm('Para reservar este turno contacta con tu centro  llamando al 666222269');
        } else {
            onTurnSelect(turn);
        }
    };

    return (
        <div>
            <ul className="available-turns-list">
                {turns.map((turn) => (
                    <li key={turn.turn_id} 
                        onClick={() => handleTurnClick(turn)}
                        className={`turn ${selectedTurn && selectedTurn.turn_id === turn.turn_id ? 'selected' : ''}`}
                    >
                        {turn.turn_short_name} ({turn.time_start} - {turn.time_end})
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AvailableTurns;
